module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Towel-deb0ab022740355c00d017d51f35fd60.svg";